module.exports = "<button type=\"button\" class=\"btn btn-rose btn-xs\" (click)=\"openDialog()\">\n    <i class=\"fa fa-image mr-4\"></i> ADICIONAR FOTO\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/upload/upload.component.html
// module id = ./src/app/shared/upload/upload.component.html
// module chunks = main